const MAPBOX_CONFIG = {
  accessToken:
    "pk.eyJ1IjoicmFqLWJyaWRnZXBvcnQiLCJhIjoiY2psY243bWg1MDJhMjN2cGF6ZjFoZ3lpaiJ9.2D-qzwUDMMECBfZra_j33Q",
}

const NUMERIC_FIELD_KINDS = ["Number", "Money", "Area", "Length", "Distance"]

export { MAPBOX_CONFIG, NUMERIC_FIELD_KINDS }
